export default __webpack_public_path__ + "static/media/logo.edc6d55c.svg";